module.exports = {
    nullTips: '用户名和密码不能为空',
    loginWrong: '用户名或密码不正确',
    userName: '用户名',
    password: '密码',
    login: '登录'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.zh-cn.js
// module id = 4
// module chunks = 0